import type { Blocker } from './database.types';

// Coerce the jsonb value from tb_tasks.blocked_by into a typed Blocker[].
// Handles:
//   - null / undefined → []
//   - proper Blocker[] → returned as-is
//   - legacy string[] (names pasted in) → wrapped as person entries
//   - random shapes → filtered out
export function coerceBlockers(raw: unknown): Blocker[] {
  if (!raw) return [];
  if (!Array.isArray(raw)) return [];
  const out: Blocker[] = [];
  for (const item of raw) {
    if (typeof item === 'string') {
      if (item.trim()) out.push({ type: 'person', name: item.trim() });
      continue;
    }
    if (!item || typeof item !== 'object') continue;
    const obj = item as Record<string, unknown>;
    if (obj.type === 'task' && typeof obj.task_id === 'string') {
      out.push({
        type: 'task',
        task_id: obj.task_id,
        label: typeof obj.label === 'string' ? obj.label : undefined,
      });
    } else if (obj.type === 'person' && typeof obj.name === 'string') {
      out.push({
        type: 'person',
        name: obj.name,
        note: typeof obj.note === 'string' ? obj.note : undefined,
      });
    } else if (obj.type === 'external' && typeof obj.note === 'string') {
      out.push({ type: 'external', note: obj.note });
    }
  }
  return out;
}

export function blockerKey(b: Blocker, idx: number): string {
  if (b.type === 'task') return `task:${b.task_id}:${idx}`;
  if (b.type === 'person') return `person:${b.name}:${idx}`;
  return `external:${b.note.slice(0, 32)}:${idx}`;
}
